<template>
  <div id="Youtube">
    <!-- <Breadcrumb :list="list"/> -->
    <div class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
    <div class="datepickerwrap">
      <div class="leftcontent wrapitem">
       <datecomponent ref="datecomponent"></datecomponent>
        <div class="datebox">
          <button @click="refresh" class="btn weavrpurple" type="button">
            <i class="fa fa-filter"></i>
          </button>
        </div>
      </div>       
    </div> 
   <!--  <ytb ytid="Z68MRjRpwdo" :playerVars="{start:1}" ref="yt" @ready="onPlayerReady" />
    <button @click="playNow(0.1)">Play from begining</button>
    <button @click="playNow(15)">Play from 15th second</button>
    <button @click="stop">stop</button> -->
    <div class="container-fluid" >
      <div class="animated fadeIn">
        <div  style="margin:0 1px 6px 1px;text-align:center">
          <select style="width:250px;display: inline-block;" @change="refresh"  v-model="selectedProduct" class="form-control text-uppercase">
            <option v-for="d in primaryProductsOptions" :value="d.product_name">{{ d.product_name }}</option>        
          </select>
        </div>  
        <b-card style="margin-bottom:4px">
          <div><strong>Video:</strong> {{ data.video_name }} </div>
          <div><strong>Channel:</strong> {{ data.video_author }} </div>
          <div><strong>Url:</strong> <a :href="data.video_url" target="_blank"> {{ data.video_url }} </a></div>
        </b-card>
        <b-card>
          <div class="reviews-panel">
            <div v-for="d in data.data" class="each-review">
                <div class="usericon">
                  <i class="fa fa-user" style="font-size: 22px; color: silver;"></i>
                </div>
                <div class="username">
                  {{ d.author }}
                </div>
               <div class="usertimestamp">
                 {{ d.timestamp }}
               </div>
               <div class="usertext">
                 {{ d.text }}
               </div>
             </div>
          </div>
        </b-card>  
      </div>
    </div>
  </div>
  
</template>

<script> 
import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
import CardBarChartExample from './dashboard/CardBarChartExample'
import MainChartExample from './dashboard/MainChartExample'
import SocialBoxChartExample from './dashboard/SocialBoxChartExample'
import CalloutChartExample from './dashboard/CalloutChartExample'
import { Callout } from '@coreui/vue'
import moment from 'moment'
import datecomponent from './date.vue'

export default {
  name: 'Sentiment',
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
    datecomponent
  },

  data: function () {
    return {
      data: [],
      dateDropDown: 'custom',
      userData: JSON.parse(localStorage.getItem('reviewUserData')),
      customData: JSON.parse(localStorage.getItem('reviewCustomData')),
      primaryProductsOptions: [],
      selectedProduct: '',
      loader: true,
      date:{},
      userData: JSON.parse(localStorage.getItem('reviewUserData')),
    }
  },
  mounted()
  {
    this.primaryProductsOptions = this.customData.primaryProductOptions
    this.selectedProduct  = this.customData.selectedProducts[0]
    this.refresh()
    
  },
  methods: {
    stop(){
      this.$refs.yt.player.stopVideo()
    },
    playNow(startTime){
      this.$refs.yt.player.loadVideoById(
        {
          videoId: "Z68MRjRpwdo",
          startSeconds: startTime,
          endSeconds: 60
        }
      )
    },
    onPlayerReady(){
      this.$refs.yt.player.seekTo({start:1})
    },
    refresh(){
      this.date = this.$refs.datecomponent.date
      this.getData()
    },
  
    getData()
    {
      this.loader = true
      const url = "/api/reviews/youtube?start_date=" + this.date.startDate + "&end_date=" + this.date.endDate + "&product=" + this.selectedProduct
      this.$http.get(url).then(response => {
        this.data = response.body.data
        this.loader = false
      }, err => {
        this.loader = false
      });
    },
  }
}

</script>

<style scoped>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
  .card_vivo
  {
    background-color: #0072ba !important;
    border: 1px solid #0072ba !important;
  }
  .card_realme
  {
    background-color: #f3b821 !important;
    border: 1px solid #f3b821 !important;
  }
  .card_redmi
  {
    background-color: #f56628 !important; 
    border: 1px solid #f56628 !important;
  }

  .badge
  {
    padding: 5px;
    font-size: 13px;
  }
  .redbg
  {
    color:red;
    cursor:pointer;
  }
  .greenbg
  {
    color: green;
    cursor:pointer;
  }
  .highcharts-figure .chart-container {
  width: 300px;
  height: 200px;
  float: left;
}


</style>
